var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-documents__upload",attrs:{"data-cy":"documentsUpload"}},[_c('UploadInterface',{attrs:{"filesList":_vm.filesList},on:{"show-message":_vm.showMessage,"reset-message":_vm.resetMessage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }